import * as React from 'react';
import * as ReactDom from 'react-dom';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import $ from 'jquery';
var Config: any = require('../../Config.json');

export interface CustomEditRendererState {
    isEditMode: boolean;
    isDisabled: any;
    strvalue: any;

}

var self;
var isValidStr = true;

export class GridValidateStringMultiTextCellEditorRenderer extends React.Component<any, CustomEditRendererState> {
    private inputRef: React.RefObject<HTMLInputElement>;
    constructor(props: any) {
        super(props);

        this.state = {
            isEditMode: false,
            isDisabled: null,
            strvalue: props.value,

        };
        this.inputRef = React.createRef();
        self = this;
    }

    componentDidMount() {
        $('.validating-msg').hide();
        this.inputRef.current.focus();
        this.setState({ isDisabled: false });

    }
    setSaveButtonDisabled(flag) {
        this.setState({ isDisabled: flag });
    }

    isCancelAfterEnd() {

        let value = this.getValue();
        if (!this.isValid(value)) {
            return true;
        }
        return false;
    }


    isCancelBeforeStart() {
        return false;
    }


    getValue() {
        return this.state.strvalue;
    }

    isValid = function (val) {
        isValidStr = this.props.validationCondition(val);
        const numregex = new RegExp(/^[a-zA-Z0-9]+$/);
        if ((val === '' || numregex.test(val)) && (isValidStr)) {
            return true;
        } else {
            return false;
        }
    }

    strcellValueChange(event: any) {
        let val = event.target.value;
        var preloader = document.getElementById("strclr");

        if (this.isValid(val)) {
            preloader.classList.remove('red-bg');
            $('.validating-msg').hide();
            $('#validating-resultRight').show();
            $('#validating-resultCross').hide();
        } else {
            preloader.classList.add('red-bg');
            $('.validating-msg').show();
            $('#validating-resultRight').hide();
            $('#validating-resultCross').show();

        }
        this.setState({ strvalue: event.target.value });
    }

    componentWillReceiveProps(nextprops: any) {


    }


    public render() {
        return <div className="tooltipOverflow">
            <input type="text" ref={this.inputRef} id="strclr" value={this.state.strvalue} onChange={e => this.strcellValueChange(e)} className='required-editor' aria-multiline="true" />
            <span id="validating-msg" className="validating-msg"> {this.props.errorMessage} </span>
            <span id="validating-resultRight" className="validating-result"><i className="fa fa-check" aria-hidden="true"></i></span>
            <span id="validating-resultCross" className="validating-result"><i className="fa fa-times" aria-hidden="true"></i></span>
        </div>;
    }
}